import React from "react";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { useCustomParams } from "../../../hooks/useCustomParams";
import CustomSelectDropdown from "../../../components/CustomSelectDropDown";
import PrimaryButton from "../../../components/Button/Button";



function LeftFilters() {
  const [status, updateStatus] = useCustomParams("status");
  const statusCount = useSelector((state) => state.compliance.count);
  const isMobile = useMediaQuery({ maxWidth: "690px" });
  const buttons = [
    { label: `Total ${statusCount?.total || ""}`, value: "" },
    { label: `Returned ${statusCount?.completed || ""}`, value: "completed" },
    { label: `Pending ${statusCount?.pending || ""}`, value: "pending" },
    {
      label: `Notice Missing ${statusCount?.notice_needed || ""}`,
      value: "notice_needed",
    },
  ];

  const buttons2 = [
    { label: "Total", value: "", total: statusCount?.total || "" },
    {
      label: "Returned",
      value: "completed",
      total: statusCount?.completed || "",
    },
    { label: "Pending", value: "pending", total: statusCount?.pending || "" },
    {
      label: "Notice Missing",
      value: "notice_needed",
      total: statusCount?.notice_needed || "",
    },
  ];

  return (
    <div>
      {isMobile ? (
        <CustomSelectDropdown
          options={buttons}
          label="Filter by Days"
          onSelectChange={(value) => updateStatus("date", value)}
          defaultValue={status}
        />
      ) : (
        buttons2.map((el, idx) => {
          return (
            <PrimaryButton
              variant="contained"
              key={idx}
              className={`capitalize ${
                el.value == status ? "btn-bg-grey" : "btn-bg-light-grey"
              } `}
              onClick={() => updateStatus("status", el.value)}
            >
              {el.label}{" "}
              <span
                className={`${
                  el.value == status ? "survey-count-select" : "survey-count"
                } `}
              >{` ${el.total}`}</span>
            </PrimaryButton>
          );
        })
      )}
    </div>
  );
}

export default LeftFilters;
